import { BasicLayout } from '@tencent/tds-ui/src/layout';
import { TdsFooter } from '@tencent/tds-ui/src/tds-footer';
import { Spin } from 'antd';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import BuglyIcon from '@/assets/images/public/bugly2.0.react.svg?react';
import { isInternal } from '@/infrastructure/auth';
import { pushHistory } from '@/infrastructure/history';
import { logger } from '@/infrastructure/logger';
import { Banner } from '@/presentation/components/banner';
import { OperationNotice } from '@/presentation/components/operation-notice';
import { useAuthContext } from '@/presentation/hooks';
import { Content } from '@/presentation/layouts/content';
import { TopMenu } from '@/presentation/layouts/header';
import { AppList } from '@/presentation/layouts/header/app-list';
import { Tools } from '@/presentation/layouts/tools';
import {
  getEntriesRoutes,
  getOverlaysRoutes,
} from '@/presentation/routes/routes';
import { stores, useStores } from '@/presentation/store';
import style from './index.module.scss';
export const AppLayout = observer(() => {
  useTranslation();
  const { loaded, productId, hasProduct } = stores.ProductStore;
  const { setCollapsed, layoutLoading, loadingMessage } = useStores().LayoutStore;
  const { authInfo } = useAuthContext();
  const history = useHistory();
  const location = useLocation();

  const handlePath = (path: string) => {
    pushHistory(history, path);
  };

  const isConfig = location.pathname.includes('/config-manage');
  const liteModeRoutes = ['/workbench/apps', '/user/profile', '/config-manage', '/git/oauth', '/', '/silence', '/user/token'];

  useEffect(() => {
    logger.info(
      'AppLayout|render',
      productId,
      location.pathname,
      loaded,
      authInfo,
    );
    // 无产品选中，跳首页 登录了情况才跳
    if (loaded && !productId && !liteModeRoutes.includes(location.pathname)) {
      // pushHistory(history, '/index/main');
      window.location.href = '/';
    }
  }, [loaded, productId]);

  useEffect(() => {
    if (isInternal() && authInfo?.isLoggedIn) {
      stores.ProductStore.initForInternal();
    }
  }, []);

  // 没登录不render
  if (!authInfo?.isLoggedIn) {
    return null;
  }

  if (location.pathname === '/') {
    return <Content />;
  }

  return (
    <Spin
      spinning={layoutLoading}
      tip={loadingMessage}
      className={style.loading}
    >
      <BasicLayout
        menuProps={{
          className: style.menu,
        }}
        liteMode={!hasProduct}
        showBreadcrumb={hasProduct}
        className={classnames({
          [style.app]: true,
          [style.config]: isConfig,
        })}
        leftMenuRoutes={{ routes: getEntriesRoutes() }}
        overlayMenuRoutes={{ routes: getOverlaysRoutes() }}
        appSelector={<AppList />}
        topMenu={<TopMenu />}
        liteModeRoutes={liteModeRoutes}
        logo={
          <a href='/'>
            <BuglyIcon />
          </a>
        }
        setCollapsed={setCollapsed}
        handlePath={handlePath}
        title={'Bugly'}
        renderBanner={(showBanner, setShowBanner) => (
            <Banner
              showBanner={showBanner}
              setShowBanner={setShowBanner}
              liteModeRoutes={liteModeRoutes}
            />
        )}
      >
        <div className={classnames(style.containerLayout, 'content-layout')}>
          <Content />
          <TdsFooter isWoa={!isInternal()} />
          <Tools />
        </div>
      </BasicLayout>

      {/* 运营公告组件 */}
      <OperationNotice liteModeRoutes={liteModeRoutes} />
    </Spin>
  );
});
